import { z } from 'zod'
import { ShoppingPromotionSchema } from '@reward-platform/shared-schemas'
import { CurrencyCodesSchema } from '@reward-platform/platform-config'
import { PricedPaymentOptionSchema } from './payment-option'

export const AmountSchema = z.object({
  amount: z.number(),
  currencyCode: CurrencyCodesSchema,
})

export const PriceSchema = z
  .object({
    priceId: z.string(),
  })
  .catchall(AmountSchema)

export const PriceLadderSchema = z.object({
  aviosPrice: z.number(),
  cashPrice: z.number(),
  cashPriceWithSurcharges: z.number().optional(),
  promotions: z.array(ShoppingPromotionSchema).optional(),
  collectAmount: z.number().optional(),
})

export const PackageTotalPriceSchema = z.array(PriceSchema)

export const PricingDataSchema = z.object({
  cashPrice: z.number().optional(),
  cashPriceWithSurcharges: z.number().optional(),
  aviosPrice: z.number().optional(),
  baseAmount: z.number().optional(),
  collectAmount: z.number().optional(),
  currencyCode: CurrencyCodesSchema,
  paymentOptions: z.array(PricedPaymentOptionSchema).optional(),
  pricingLadder: z.array(PriceLadderSchema.partial()).optional(),
  promotions: z.array(ShoppingPromotionSchema.partial()).optional(),
  surcharges: z.number().optional(),
  baseLoyalty: z.number().optional(),
})

export type Amount = z.infer<typeof AmountSchema>
export type Price = z.infer<typeof PriceSchema>
export type PriceLadder = z.infer<typeof PriceLadderSchema>
export type PricingData = z.infer<typeof PricingDataSchema>
